import { create } from 'zustand';
import { Icons } from '@shared/ui';
import i18n from '@shared/i18n';
import { AUX_BAR_ITEM_ENUM, SIDEBAR_UPPER_NAV_TAB_ENUM } from './constants';

const auxBarItemMap = {
    [AUX_BAR_ITEM_ENUM.COMPONENT]: {
        type: AUX_BAR_ITEM_ENUM.COMPONENT,
        name: i18n.gettext('元件'),
        icon: Icons.csr.CirclesThreePlus,
    },
    [AUX_BAR_ITEM_ENUM.SECTION]: {
        type: AUX_BAR_ITEM_ENUM.SECTION,
        name: i18n.gettext('區塊'),
        icon: Icons.csr.SquaresFour,
    },
    [AUX_BAR_ITEM_ENUM.STYLE]: {
        type: AUX_BAR_ITEM_ENUM.STYLE,
        name: i18n.gettext('樣式'),
        icon: Icons.csr.Palette,
    },
    [AUX_BAR_ITEM_ENUM.PAGE_TREE]: {
        type: AUX_BAR_ITEM_ENUM.PAGE_TREE,
        name: i18n.gettext('排序'),
        icon: Icons.csr.StackSimple,
    },
} as const;

export interface UseSidebarState {
    sideBarOpen: boolean;
    styleToolOpen: boolean;
    currentAuxBar: AUX_BAR_ITEM_ENUM | null;
    sidebarCurrentTab: SIDEBAR_UPPER_NAV_TAB_ENUM;
    auxBarItemMap: typeof auxBarItemMap;
    proceedEditingNewElement: boolean;
}

export interface UseSidebarActions {
    setCurrentAuxBar: (auxName: UseSidebarState['currentAuxBar']) => void;
    setSideBarOpen: (isOpen: boolean) => void;
    setStyleToolOpen: (isOpen: boolean) => void;
    setProceedEditingNewElement: (shouldProceed: boolean) => void;
    setSidebarCurrentTab: (tab: UseSidebarState['sidebarCurrentTab']) => void;
}

export const useSidebarStore = create<UseSidebarState & UseSidebarActions>((set) => ({
    sideBarOpen: false,
    styleToolOpen: false,
    currentAuxBar: null,
    auxBarItemMap,
    proceedEditingNewElement: false,
    sidebarCurrentTab: SIDEBAR_UPPER_NAV_TAB_ENUM.RICH_TEXT,
    setSidebarCurrentTab: (tab: UseSidebarState['sidebarCurrentTab']) =>
        set({ sidebarCurrentTab: tab }),
    setCurrentAuxBar: (auxName) =>
        set({ currentAuxBar: auxName, proceedEditingNewElement: false }),
    setSideBarOpen: (isOpen: boolean) => set({ sideBarOpen: isOpen }),
    setStyleToolOpen: (isOpen: boolean) => set({ styleToolOpen: isOpen }),
    setProceedEditingNewElement: (shouldProceed: boolean) =>
        set({ proceedEditingNewElement: shouldProceed }),
}));
